/* tslint:disable */

declare var Object: any;
export interface SucursalInterface {
  "idsucursal": number;
  "nombre"?: string;
}

export class Sucursal implements SucursalInterface {
  "idsucursal": number;
  "nombre": string;
  constructor(data?: SucursalInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Sucursal`.
   */
  public static getModelName() {
    return "Sucursal";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Sucursal for dynamic purposes.
  **/
  public static factory(data: SucursalInterface): Sucursal{
    return new Sucursal(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Sucursal',
      plural: 'Sucursals',
      path: 'Sucursals',
      idName: 'idsucursal',
      properties: {
        "idsucursal": {
          name: 'idsucursal',
          type: 'number'
        },
        "nombre": {
          name: 'nombre',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/lb-sdk/models/Sucursal.ts